import { CORTEX_SUPPORT_URL } from 'clipsal-cortex-utils/src/constants/common-constants';

export const METER_WATTWATCHERS_TROUBLESHOOTING_ARTICLE_URL =
  'https://www.clipsal.com/getmedia/33f86876-f4aa-4a3f-a16c-7374ea895099/how-to-power-cycle-your-cortex-meter.pdf';

export const METER_CATCH_TROUBLESHOOTING_ARTICLE_URL =
  'https://www.clipsal.com/getmedia/33136334-d2ae-4ab9-b7c1-e5ed6326b7f6/how-to-reconnect-your-cortex-meter.pdf';

export const HYBRID_INVERTER_TROUBLESHOOTING_ARTICLE_URL =
  'https://www.clipsal.com/getmedia/d3623e6a-a840-47e2-ac87-501dce20a4bc/how-to-reconnect-your-inverter-to-wifi.pdf';

export const SENSIBO_DEVICE_TROUBLESHOOTING_ARTICLE_URL =
  'https://www.clipsal.com/getmedia/d0e0d180-84b4-41f1-9847-3c987f0cd646/how-to-configure-your-sensibo-device.pdf';

// No EV charger guide is published on the Cortex resources page yet.
export const EV_DEVICE_TROUBLESHOOTING_ARTICLE_URL = CORTEX_SUPPORT_URL;

export const APP_FEEDBACK_URL = CORTEX_SUPPORT_URL;
